import { makeStyles } from 'tss-react/mui'
import useModals from 'src/Hooks/useModals'
import { Button } from '@mui/material'
import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DeviceInfoForStatement } from 'src/Libs/installation-statement/components/Modals/InstallationStatementDialog'

const useStyles = makeStyles()(theme => ({
  installationStatementAddButton: {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    width: '6rem',
  },
  installationStatementEditButton: {
    color: theme.palette.warning.main,
    borderColor: theme.palette.warning.main,
    width: '6rem',
    ':hover': {
      borderColor: theme.palette.warning.main,
      backgroundColor: '#E6A64C0A',
    },
  },
}))

interface InstallationStatementButtonProps {
  installation: DeviceInfoForStatement
  disabled?: boolean
}

/**
 * This component is rendered in the Missing Ibn table, opening the Installation Statement dialog for the selected
 * installation.
 * @param installation - the installation, the dialog will be opened for.
 * @constructor
 */
const InstallationStatementButton: React.FC<InstallationStatementButtonProps> = ({ installation, disabled = false }) => {
  const { t } = useCustomTranslation()
  const { openInstallationStatementDialog } = useModals()
  const { classes } = useStyles()

  const onButtonClick = (): void => {
    openInstallationStatementDialog({ installation })
  }

  const incompleteStatement = Boolean(installation.installationStatementId)

  return (
    <Button
      onClick={onButtonClick}
      key={installation.id}
      className={incompleteStatement ? classes.installationStatementEditButton : classes.installationStatementAddButton}
      disabled={disabled}
    >
      {incompleteStatement ? t('common.continue') : t('common.hand-in')}
    </Button>
  )
}

export default InstallationStatementButton
